import { Component, Input, OnInit } from '@angular/core';
import { Product } from '../../../core/models';
import { ProductMarketRowItemComponent } from './../product-market-row-item/product-market-row-item.component';

@Component({
    selector: 'app-products-market-row',
    standalone: true,
    imports: [ProductMarketRowItemComponent],
    templateUrl: './products-market-row.component.html',
    styleUrls: ['./products-market-row.component.css'],
})
export class ProductsMarketRowComponent implements OnInit {

  @Input() products: Product[];
  @Input() showRestaurantName?: boolean = true;
  
  constructor() { }

  ngOnInit(): void {
  }

}
